import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';
import { toast } from "react-toastify";

/*************
 * /vehicle/image/submission
 * Upload image to server
 * *************/
export const uploadImages = createAsyncThunk(
  "user/uploadImages",
  async (bodyContent) => {
    const response = await ApiService.post("/vehicle/image/submission", bodyContent);
    const data = await response.data;
    return data;
  }
);

/*************
 * /vehicle/image/status
 * Get image status
 * *************/
export const getImageStatus = createAsyncThunk(
  "user/getImageStatus",
  async (imageUrl) => {
    const response = await ApiService.get(`/vehicle/image/status?image_url=${imageUrl}`);
    const data = await response.data;
    return data;
  }
);

/*************
 * /vehicle/image/result
 * Get image to server
 * *************/
export const getImage = createAsyncThunk(
  "user/getImage",
  async (imageUrl) => {
    const response = await ApiService.get(`/vehicle/image/result?image_url=${imageUrl}`, {
      responseType: 'blob'
    } );
    const data = await response.data;
    return data;
  }
);

const initialState = {
  loading: false,
  error: null,
  isLogin: localStorage.getItem('user') || false,
  dimension: "",
  inputImages: null,
  previewImages: null,
  bg_id: null,
  showroom: null,
  window_refinement: { 'TRANSPARENCY': null, 'TINT_COLOR': "(166, 205, 203)", 'TONE_ON_TONE': false, 'ADD_GLARE': true },
  interior_regeneration: 1,
  number_plate: null,
  extension: "",
  resData: null,
  sku_id: null,
  model_version: "1.0.0",
  input_url: null,
  output_url: "",
  status: "",
  isResubmit: false,
  activeUrl:null,
  title:null,
  zoomModelVisibility:false
}
export const carrommSlice = createSlice({
  name: 'carromm',
  initialState: initialState,
  reducers: {
    setInputImages: (state, action) => {
      state.output_url = "";
    },
    setPreviewImages: (state, action) => {
      state.previewImages = action.payload;
    },
    resetSkuId: (state, action) => {
      state.sku_id = null;
    },
    setBG: (state, action) => {
      state.bg_id = action.payload;
    },
    setShowRoom: (state, action) => {
      state.showroom = action.payload;
    },
    setWindowRefinementTransparency: (state, action) => {
      state.window_refinement.TRANSPARENCY = action.payload;
    },
    toggleGlare: (state, action) => {
      state.window_refinement.ADD_GLARE = action.payload;
    },
    setNumberPlate: (state, action) => {
      state.number_plate = action.payload;
    },
    setLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setDimension: (state, action) => {
      state.dimension = action.payload;
    },
    setInputUrl: (state, action) => {
      state.input_url = action.payload;
    },
    setOutputUrl: (state, action) => {
      state.output_url = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setResubmit: (state, action) => {
      state.isResubmit = action.payload;
    },
    setActiveUrl: (state, action) => {
      state.activeUrl = action.payload;
    },
    setTitle:(state, action)=>{
      state.title = action.payload;
    },
    setZoomModelVisibility: (state, action) => {
      state.zoomModelVisibility = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(uploadImages.pending, (state, payload) => {
      state.loading = true;
    })
    builder.addCase(uploadImages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ? action.payload.errorMessage : action?.error?.message;
      toast.error(action.payload ? action.payload.errorMessage : action?.error?.message);
    })
    builder.addCase(uploadImages.fulfilled, (state, action) => {
      state.loading = false;
      console.log("action?.payload", action?.payload?.data?.images?.[0]?.status, action?.payload?.data?.images?.[0]?.image);
      if (action?.payload?.data?.images?.[0]?.status === "processing" || action?.payload?.data?.images?.[0]?.status === "raw") {
        state.sku_id = action?.payload?.data?.images?.[0]?.image;
        state.status = action?.payload?.data?.images?.[0]?.status;
      } else {
        state.status = "submission-error";
        toast.error("Server-Fehler: Bild nicht auf Server hochgeladen mit Status" + action?.payload?.data?.images?.[0]?.error + ".");
      }
    })

    builder.addCase(getImageStatus.pending, (state, payload) => {
      state.loading = true;
    })
    builder.addCase(getImageStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ? action.payload.errorMessage : action?.error?.message;
      toast.error(action.payload ? action.payload.errorMessage : action?.error?.message);
    })
    builder.addCase(getImageStatus.fulfilled, (state, action) => {
      state.loading = false;
      if (action?.payload?.data?.images?.[0]?.status) {
        state.status = action?.payload?.data?.images?.[0]?.status;
      } else {
        toast.error("Server-Fehler: Bild nicht auf Server hochgeladen mit Status" + action?.payload?.data?.images?.[0]?.error + ".");
      }
    })

    builder.addCase(getImage.pending, (state, payload) => {
      state.loading = true;
    })
    builder.addCase(getImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ? action.payload.errorMessage : action?.error?.message;
      toast.error(action.payload ? action.payload.errorMessage : action?.error?.message);
    })
    builder.addCase(getImage.fulfilled, (state, action) => {
      state.loading = false;  // Correctly mutate state
      
      const payload = action.payload;
      if (payload instanceof Blob) {
        console.log("output 1");
        const imageObjectURL = URL.createObjectURL(payload);
        state.output_url = imageObjectURL;
      } else if (typeof payload === 'string') {
        console.log("output 2");
        state.output_url = payload;
      } else {
        console.log("output 3");
        console.error('Unexpected payload type:', typeof payload);
      }
    })
  },
})
export const {
  setInputImages,
  setPreviewImages,
  resetSkuId,
  setBG,
  setShowRoom,
  setWindowRefinementTransparency,
  toggleGlare,
  setNumberPlate,
  setLogin,
  setDimension,
  setInputUrl,
  setOutputUrl,
  setStatus,
  setResubmit,
  setActiveUrl,
  setTitle,
  setZoomModelVisibility
} = carrommSlice.actions;
export default carrommSlice.reducer;
